import data from "../../../../../src/Pagehead.docs.json";
import * as React from 'react';
export default {
  data,
  React
};